import { MobileSplitsColumns } from "./MobileSplitsColumns";

export const MobileSplitsTable = (pdf, startY, summaryUnitLabels, waypointDataSimple) => {
    const smallColsWidth = 140;

    pdf.autoTable(MobileSplitsColumns(summaryUnitLabels), waypointDataSimple, {
      startY: startY, // pdf.internal.pageSize.getHeight() / 2 + 20
      margin: {
        horizontal: 0,
        vertical: 20,
      },
      styles: {
        fontSize: 60,
        overflow: "linebreak",
        fillColor: "#212529",
        textColor: "#FFFFFF",
        valign: "top",
        cellPadding: 20,
        lineColor: "#FFFFFF",
        lineWidth: {top: 0, right: 0, bottom: 5, left: 0},
      },
      headStyles: {
        fillColor: "#FFFFFF",
        fontStyle: 'normal',
        fontSize: 48,
        textColor: "#003d73"
      },
      columnStyles: {
        title: { 
          halign: 'left', fontSize: 72, fontStyle: 'bold', fillColor: "#003d73"  },
        elapsedTime: { 
          halign: 'right', fontSize: 48, fillColor: "#003d73", valign: 'top', minCellWidth: smallColsWidth + 50, },
        distance: { 
          halign: 'right', fontSize: 48, fillColor: "#003d73", valign: 'top', minCellWidth: smallColsWidth, },
        pace: { 
          halign: 'left', fontSize: 48, fillColor: "#003d73", valign: 'top',  minCellWidth: smallColsWidth, },
      },
      theme: "striped",
      // showHead: "never",
    });
  };
